import useUserState from '../../states/useUserState';
import ProfilePage from './ProfilePage';

const PersonalProfilePage: React.FC = () => {
  const { userId } = useUserState();
  if (!userId) return null;
  return <ProfilePage userId={userId} />;
};

export default PersonalProfilePage;
